var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_P",
    "data-name": "Icon P",
    transform: "translate(-144 -385.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Backing_circle",
    "data-name": "Backing circle",
    transform: "translate(145.5 386.76)",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Backing_circle-2",
    "data-name": "Backing circle",
    transform: "translate(151.5 392.76)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0A32,32,0,1,1,0,32,32,32,0,0,1,32,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32 1 C 27.81459045410156 1 23.75490188598633 1.819499969482422 19.93370819091797 3.435718536376953 C 16.24237060546875 4.997028350830078 12.92699813842773 7.232379913330078 10.07968902587891 10.07968902587891 C 7.232379913330078 12.92699813842773 4.997028350830078 16.24237060546875 3.435718536376953 19.93370819091797 C 1.819499969482422 23.75490188598633 1 27.81459045410156 1 32 C 1 36.18540954589844 1.819499969482422 40.24510192871094 3.435718536376953 44.06629180908203 C 4.997028350830078 47.75762939453125 7.232379913330078 51.072998046875 10.07968902587891 53.92031097412109 C 12.92699813842773 56.76762008666992 16.24237060546875 59.00297164916992 19.93370819091797 60.56428146362305 C 23.75490188598633 62.18050003051758 27.81459045410156 63 32 63 C 36.18540954589844 63 40.24510192871094 62.18050003051758 44.06629180908203 60.56428146362305 C 47.75762939453125 59.00297164916992 51.072998046875 56.76762008666992 53.92031097412109 53.92031097412109 C 56.76762008666992 51.072998046875 59.00297164916992 47.75762939453125 60.56428146362305 44.06629180908203 C 62.18050003051758 40.24510192871094 63 36.18540954589844 63 32 C 63 27.81459045410156 62.18050003051758 23.75490188598633 60.56428146362305 19.93370819091797 C 59.00297164916992 16.24237060546875 56.76762008666992 12.92699813842773 53.92031097412109 10.07968902587891 C 51.072998046875 7.232379913330078 47.75762939453125 4.997028350830078 44.06629180908203 3.435718536376953 C 40.24510192871094 1.819499969482422 36.18540954589844 1 32 1 M 32 0 C 49.67311096191406 0 64 14.32688903808594 64 32 C 64 49.67311096191406 49.67311096191406 64 32 64 C 14.32688903808594 64 0 49.67311096191406 0 32 C 0 14.32688903808594 14.32688903808594 0 32 0 Z",
    stroke: "none",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ring",
    "data-name": "Icon ring",
    transform: "translate(148.742 390.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Inner_circle",
    "data-name": "Inner circle",
    cx: 34.579,
    cy: 34.579,
    r: 34.579,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0H44.684V44.684H0Z",
    transform: "translate(12.237 12.237)",
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/Ring_icon.06975e0e7289f0ad35b1fa61210ccfa6.svg";
export { ForwardRef as ReactComponent };